<template lang="pug">
    div
        Button(@click="addRule()") {{ $t("intelligentProtectionSettings.addText") }}
        // wafRuleList.rules
        List.rules-list
            // 可拖拽的 Detects
            draggable(
                    v-model="draggableRules"
                    handle=".drag-handle"
                    @start="drag=true"
                    @end="drag=false"
                )
                ListItem.rules-listItem(v-for="(rule, index) in draggableRules" :key="index")
                    div.rules-listItem-title
                        section.rules-listItem-title-section(@click="togglePanel(index, rule)")
                            Icon.rules-listItem-arrow(type="ios-arrow-forward" :class="{ 'rules-listItem-arrow-active': openedIndexes.includes(index) }")
                            span.rules-listItem-span {{ getPanelTitle(rule) }}
                        section
                            Icon.drag-handle.rules-listItem-menu(type="md-menu")
                    div.rules-listItem-content(v-if="openedIndexes.includes(index)")
                        rule.rules-listItem-rule(v-model="draggableRules[index]" :formData="formData" :formItem="rule" :prop-prefix="propPrefix + index" :groupName="groupName")
                        section.rules-listItem-footer
                            Button(@click="deleteRule(index)") {{ $t("rcmtable.deleteText") }}
                            Button(type="primary" @click="togglePanel(index, rule)") {{ $t("intelligentProtectionSettings.collapseText") }}
            // 不可拖拽的 Actions
            div
                ListItem.rules-listItem(v-for="(rule, index) in fixedRules" :key="index")
                    div.rules-listItem-title
                        section.rules-listItem-title-section(@click="togglePanel(draggableRules.length + index, rule)")
                            Icon.rules-listItem-arrow(type="ios-arrow-forward" :class="{ 'rules-listItem-arrow-active': openedIndexes.includes(draggableRules.length + index) }")
                            span.rules-listItem-span {{ getPanelTitle(rule) }}
                    div.rules-listItem-content(v-if="openedIndexes.includes(draggableRules.length + index)")
                        rule.rules-listItem-rule(v-model="fixedRules[index]" :formData="formData" :formItem="rule" :prop-prefix="propPrefix + (draggableRules.length + index)" :groupName="groupName")
                        section.rules-listItem-footer
                            Button(type="primary" @click="togglePanel(draggableRules.length + index, rule)") {{ $t("intelligentProtectionSettings.collapseText") }}
</template>
<script>
import draggable from "vuedraggable";
import rule from "./rule";
import { wafActionToString } from "@/libs/utils.js";

export default {
    name: "rules",
    props: {
        value: {
            type: Array,
            default: () => [],
        },
        formData: {},
        formItem: {},
        groupName: {
            type: String,
            default: () => "",
        },
    },
    components: { draggable, rule },
    data() {
        return {
            openedIndexes: [],
            propPrefix: "rules.",
        };
    },
    computed: {
        draggableRules: {
            get() {
                return this.value.filter((rule) => rule.type === "detect");
            },
            set(newValue) {
                // 當拖拽結束時，重新組合：[新排序的 detect] + [原本的 action]
                const actions = this.value.filter((rule) => rule.type === "action");
                this.$emit("input", [...newValue, ...actions]);
            },
        },
        fixedRules() {
            return this.value.filter((rule) => rule.type === "action");
        },
    },
    methods: {
        async togglePanel(index, rule) {
            const position = this.openedIndexes.indexOf(index);
            if (position === -1) {
                // 這筆資料「不在」陣列中
                this.openedIndexes.push(index);
                return;
            }

            // 這筆資料「在」陣列中
            const fieldsToCheck = Object.keys(rule).map((key) => `${this.propPrefix}${index}.${key}`);
            this.$emit("request-validate", fieldsToCheck, (isValid) => {
                if (!isValid) return;
                this.openedIndexes.splice(position, 1);
            });
        },
        getPanelTitle(rule) {
            const capitalize = (string) => {
                if (!string) return "";
                return string.charAt(0).toUpperCase() + string.slice(1);
            };
            const type = capitalize(rule.type);
            const name = rule.type === "action" ? wafActionToString(rule.name) : this.$t(`wafrules.${rule.name}`);
            return `${type}: ${name}`;
        },
        deleteRule(index) {
            this.openedIndexes = this.openedIndexes
                .filter((i) => {
                    return i !== index;
                })
                .map((i) => {
                    if (index < i) {
                        return i - 1;
                    }
                    return i;
                });

            const newValue = [...this.value];
            newValue.splice(index, 1);
            this.$emit("input", newValue);
        },
        addRule() {
            const newRule = {
                type: "detect",
                name: "wafIp",
                isPositive: true,
                ip: [],
                uri: [],
                headers: [],
                headersExist: [],
                country: [],
                isp: [],
                proxyType: [],
                ja3Hashes: [],
                httpMethod: [],
                rateLimitCount: 0,
                rateLimitWindow: 0,
                rateLimitToken: {
                    group: true,
                    ruleName: true,
                    ip: true,
                    host: true,
                    uri: false,
                    method: false,
                    country: false,
                    ua: false,
                    // customSign: false,
                    // customSignValue: "",
                },
                denyHtmlPageName: "default",
                denyThenBucket: false,
                denyThenBucketRateLimitCount: 0,
                denyThenBucketRateLimitWindow: 0,
                bucketTime: 300,
                bucketPreSslDeny: false,
                bucketPreSslDenyThreshold: 0,
                globalBucketRecord: false,
                withL3BucketList: false,
                speedLimit: 10240,
                redirectUrl: {},
                redirectHttpCode: 302,
                setReqHeaders: [],
                setResHeaders: [],
                customHtmlPageName: "",
                originPolicyName: "",
                hotlinkSecretKey: "",
                hotlinkTimeToLive: 60,
                hotlinkQueryArgument: "",
            };

            // 目前最後一個 rule 固定是 Action，新增的 rule 會放在其前面一位
            const newIndex = this.value.length - 1;
            const newValue = [...this.value];
            newValue.splice(newIndex, 0, newRule);
            this.$emit("input", newValue);

            this.openedIndexes.push(newIndex);
        },
        async validateAndSyncAll() {
            if (this.openedIndexes.length === 0) return true;
            const allFieldsToCheck = this.openedIndexes.flatMap((index) => {
                const row = this.value[index];
                return Object.keys(row).map((key) => `${this.propPrefix}${index}.${key}`);
            });
            return new Promise((resolve) => {
                this.$emit("request-validate", allFieldsToCheck, (isValid) => {
                    if (isValid) {
                        this.openedIndexes = [];
                    }
                    resolve(isValid);
                });
            });
        },
    },
};
</script>

<style scoped>
.rules-list {
    max-height: 350px;
    overflow: scroll;
}
.rules-listItem {
    display: block;
    padding: 0;
}
.rules-listItem-title {
    padding: 0 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #efefef;
}
.rules-listItem-title-section {
    flex: 1;
    cursor: pointer;
}
.rules-listItem-arrow {
    display: inline-block;
    transition: transform 0.2s ease-in-out;
}
.rules-listItem-arrow-active {
    transform: rotate(90deg);
}
.rules-listItem-span {
    margin: 0 16px;
}
.rules-listItem-menu {
    cursor: move;
}
.rules-listItem-content {
    padding: 16px;
    background-color: #fff;
    border: 1px solid #efefef;
    display: flex;
    flex-direction: column;
}
.rules-listItem-rule {
    display: flex;
    flex-direction: column;
    gap: 16px;
}
.rules-listItem-footer {
    margin-top: 16px;
    display: flex;
    justify-content: end;
}
</style>



// WEBPACK FOOTER //
// src/components/FormItems/wafRuleList/rules.vue